// Theme: 'light' | 'dark' | 'auto' (auto follows the OS). Applied as
// document.documentElement[data-theme] = resolved light/dark.
const KEY = 'kapstat_theme';
const mq = () => window.matchMedia('(prefers-color-scheme: dark)');

export function getMode() { return localStorage.getItem(KEY) || 'auto'; }
export function resolved(mode = getMode()) { return mode === 'auto' ? (mq().matches ? 'dark' : 'light') : mode; }
export function apply(mode = getMode()) { document.documentElement.dataset.theme = resolved(mode); }

export function setMode(mode) {
  localStorage.setItem(KEY, mode);
  apply(mode);
  window.dispatchEvent(new Event('kapstat-theme'));
}

export function initTheme() {
  apply();
  try { mq().addEventListener('change', () => { if (getMode() === 'auto') apply(); }); } catch { /* older Safari */ }
}
